import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getTotalRevenueShipped = {
  name: "getTotalRevenueShipped" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
